import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, Router } from "@angular/router";
import { Observable, of as observableOf } from 'rxjs';
import { AuthService } from '@root/modules/common/services/auth.service';
import { AlertController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate, CanActivateChild {
    constructor() {

    }

    canActivate(): Observable<boolean> {
        const isLoggedIn = this.isAccessLogin();
        return observableOf(isLoggedIn)
    }

    canActivateChild(): Observable<boolean> {
        const isLoggedIn = this.isAccessLogin();
        return observableOf(isLoggedIn)
    }
    private isAccessLogin(): boolean {
        let isLoggedIn: boolean = AuthService.isLogged();
        console.log("InitGuard-isLogged", isLoggedIn);
        if (!isLoggedIn) {
            return true;
        }
        return false;
    }
}